import { render, staticRenderFns } from "./keyword-edit-dialog.vue?vue&type=template&id=492bc6ed&scoped=true&"
import script from "./keyword-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./keyword-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492bc6ed",
  null
  
)

export default component.exports